'use client'

import { CheckCircle2, AlertCircle, Clock, Activity } from 'lucide-react'

export default function StatusPage() {
  const systems = [
    {
      name: 'API',
      status: 'planned',
      uptime: 'N/A',
      lastIncident: 'Coming Soon',
    },
    {
      name: 'Web Application',
      status: 'operational',
      uptime: '100%',
      lastIncident: 'No incidents in last 90 days',
    },
    {
      name: 'AI Services',
      status: 'operational',
      uptime: '100%',
      lastIncident: 'No incidents in last 90 days',
    },
    {
      name: 'Database',
      status: 'operational',
      uptime: '100%',
      lastIncident: 'No incidents in last 90 days',
    },
    {
      name: 'Authentication',
      status: 'operational',
      uptime: '100%',
      lastIncident: 'No incidents in last 90 days',
    },
  ]

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'operational':
        return <CheckCircle2 className="h-5 w-5 text-green-500" />
      case 'degraded':
        return <AlertCircle className="h-5 w-5 text-yellow-500" />
      case 'outage':
        return <AlertCircle className="h-5 w-5 text-red-500" />
      case 'planned':
        return <Clock className="h-5 w-5 text-blue-500" />
      default:
        return <Clock className="h-5 w-5 text-gray-500" />
    }
  }

  return (
    <div className="container max-w-7xl mx-auto px-4 py-16">
      {/* Hero Section */}
      <div className="text-center mb-16">
        <div className="flex items-center justify-center gap-2 mb-4">
          <Activity className="h-8 w-8 text-primary" />
          <h1 className="text-5xl font-bold">System Status</h1>
        </div>
        <p className="text-xl text-muted-foreground">
          Current status of GovCon Data services and components
        </p>
      </div>

      {/* Overall Status */}
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-green-500/10 text-green-500">
          <CheckCircle2 className="h-5 w-5" />
          <span className="font-medium">All Systems Operational</span>
        </div>
      </div>

      {/* Systems Grid */}
      <div className="grid md:grid-cols-2 gap-8 mb-16">
        {systems.map((system) => (
          <div key={system.name} className="border rounded-lg p-6 bg-card">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-semibold">{system.name}</h3>
              {getStatusIcon(system.status)}
            </div>
            <div className="space-y-2">
              <p className="text-sm text-muted-foreground">
                Uptime: <span className="font-medium text-foreground">{system.uptime}</span>
              </p>
              <p className="text-sm text-muted-foreground">
                Last Incident: <span className="font-medium text-foreground">{system.lastIncident}</span>
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
} 